/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 清除全部localStorage
 */
export const clearAllStore = () => {
  window.localStorage.clear();
};

/**
 * 获取cookie
 */
export const getCookie = name => {
  const cookiestring = document.cookie;
  let start = cookiestring.indexOf(name + '= ');
  if (start == -1) {
    return null;
  }
  start += cookiename.length + 1;
  const end = cookiestring.indexOf('; ', start);
  if (end == -1) return unescape(cookiestring.substring(start));
  return unescape(cookiestring.substring(start, end));
};
/**
 * 清除全部cookie
 */
export const clearCookie = () => {
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie =
        keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.kevis.com
      document.cookie =
        keys[i] +
        '=0;path=/;domain=' +
        document.domain +
        ';expires=' +
        new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.kevis.com
      document.cookie =
        keys[i] +
        '=0;path=/;domain=kevis.com;expires=' +
        new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .kevis.com
    }
  }
};
